import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5003/api'}/auth/forgot-password`, {
        email
      });

      if (response.data.success) {
        setMessage('تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني');
        setEmail('');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError(error.response?.data?.message || 'حدث خطأ أثناء إرسال طلب إعادة تعيين كلمة المرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="form-header">
          <div className="header-logos">
            <div className="logo-left">
              <img src="/images/logo-ar-black.png" alt="وزارة الصحة والسكان" className="moh-logo" />
            </div>
            <div className="header-content">
              <h1 className="main-title">مبادرة السيد رئيس الجمهورية لفحص المقبلين على الزواج</h1>
              <h2 className="form-title">استعادة كلمة المرور</h2>
            </div>
            <div className="logo-right">
              <img src="/images/egypt-logo.png" alt="جمهورية مصر العربية" className="egypt-logo" />
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="form-group">
            <label htmlFor="email">البريد الإلكتروني</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="أدخل بريدك الإلكتروني"
              required
              disabled={loading}
            />
          </div>

          {message && (
            <div className="alert alert-success">
              {message}
            </div>
          )}

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'جاري الإرسال...' : 'إرسال رابط الاستعادة'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate('/login')}
            >
              العودة لتسجيل الدخول
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;